const _temp0 = require("url:./CL_Budblob_0215_img0.ktx2");
const _temp1 = require("url:./CL_Venturecoral_0215_img0.ktx2");
const _temp2 = require("url:./CL_World_0223_img0.ktx2");
const _temp3 = require("url:./CL_World_0223_img1.ktx2");
const _temp4 = require("url:./CL_World_0223_img2.ktx2");
const _temp5 = require("url:./CL_World_0223_img3.ktx2");
const _temp6 = require("url:./CL_World_0223_img4.ktx2");
const _temp7 = require("url:./CL_World_0223_img5.ktx2");
const _temp8 = require("url:./CL_World_0223_img6.ktx2");
const _temp9 = require("url:./CL_World_0223_img7.ktx2");
const _temp10 = require("url:./CL_World_0223_img8.ktx2");
const _temp11 = require("url:./FF_Chainshroom_0215_img0.ktx2");
const _temp12 = require("url:./FF_Rotwood_0215_img0.ktx2");
const _temp13 = require("url:./FF_Shirtdress_0208_img0.ktx2");
const _temp14 = require("url:./FF_Shirtdress_0208_img1.ktx2");
const _temp15 = require("url:./FF_World_0223_img0.ktx2");
const _temp16 = require("url:./FF_World_0223_img1.ktx2");
const _temp17 = require("url:./FF_World_0223_img2.ktx2");
const _temp18 = require("url:./FF_World_0223_img3.ktx2");
const _temp19 = require("url:./FF_World_0223_img4.ktx2");
const _temp20 = require("url:./FF_World_0223_img5.ktx2");
const _temp21 = require("url:./FF_World_0223_img6.ktx2");
const _temp22 = require("url:./FF_World_0223_img7.ktx2");
const _temp23 = require("url:./FF_World_0223_img8.ktx2");
const _temp24 = require("url:./FF_World_0223_img9.ktx2");
const _temp25 = require("url:./FT_Bomber_0211_img0.ktx2");
const _temp26 = require("url:./FT_Bomber_0211_img1.ktx2");
const _temp27 = require("url:./FT_KnitVest_0211_img0.ktx2");
const _temp28 = require("url:./FT_KnitVest_0211_img1.ktx2");
const _temp29 = require("url:./FT_Multipod_0216_img0.ktx2");
const _temp30 = require("url:./FT_Shirtdress_0211_img0.ktx2");
const _temp31 = require("url:./FT_Shirtdress_0211_img1.ktx2");
const _temp32 = require("url:./FT_Swellberries_0216_img0.ktx2");
const _temp33 = require("url:./FT_World_0302_img0.ktx2");
const _temp34 = require("url:./FT_World_0302_img1.ktx2");
const _temp35 = require("url:./FT_World_0302_img10.ktx2");
const _temp36 = require("url:./FT_World_0302_img11.ktx2");
const _temp37 = require("url:./FT_World_0302_img12.ktx2");
const _temp38 = require("url:./FT_World_0302_img13.ktx2");
const _temp39 = require("url:./FT_World_0302_img14.ktx2");
const _temp40 = require("url:./FT_World_0302_img15.ktx2");
const _temp41 = require("url:./FT_World_0302_img2.ktx2");
const _temp42 = require("url:./FT_World_0302_img3.ktx2");
const _temp43 = require("url:./FT_World_0302_img4.ktx2");
const _temp44 = require("url:./FT_World_0302_img5.ktx2");
const _temp45 = require("url:./FT_World_0302_img6.ktx2");
const _temp46 = require("url:./FT_World_0302_img7.ktx2");
const _temp47 = require("url:./FT_World_0302_img8.ktx2");
const _temp48 = require("url:./FT_World_0302_img9.ktx2");
const _temp49 = require("url:./Look_CL_GreenFurSweater_0211_img0.ktx2");
const _temp50 = require("url:./Look_CL_GreenFurSweater_0211_img1.ktx2");
const _temp51 = require("url:./Look_CL_Poncho_0211_img0.ktx2");
const _temp52 = require("url:./Look_CL_Poncho_0211_img1.ktx2");
const _temp53 = require("url:./Look_CL_ShirtChino_0214_img0.ktx2");
const _temp54 = require("url:./Look_CL_ShirtChino_0214_img1.ktx2");
const _temp55 = require("url:./Look_CL_TeePintuckPant_0211_img0.ktx2");
const _temp56 = require("url:./Look_CL_TeePintuckPant_0211_img1.ktx2");
const _temp57 = require("url:./Look_FF_CropSweater_0220_img0.ktx2");
const _temp58 = require("url:./Look_FF_CropSweater_0220_img1.ktx2");
const _temp59 = require("url:./Look_FF_RibSweater_0220_img0.ktx2");
const _temp60 = require("url:./Look_FF_RibSweater_0220_img1.ktx2");
const _temp61 = require("url:./Look_FF_Shirtdress_0220_img0.ktx2");
const _temp62 = require("url:./Look_FF_Shirtdress_0220_img1.ktx2");
const _temp63 = require("url:./Look_FF_Shirtdress_0330_img0.ktx2");
const _temp64 = require("url:./Look_FF_Shirtdress_0330_img1.ktx2");
const _temp65 = require("url:./Look_FT_Coveralls_0214_img0.ktx2");
const _temp66 = require("url:./Look_FT_Coveralls_0214_img1.ktx2");
const _temp67 = require("url:./Look_Placeholder_img0.ktx2");
module.exports = {
  "CL_Budblob_0215_img0.ktx2": _temp0,
  "CL_Venturecoral_0215_img0.ktx2": _temp1,
  "CL_World_0223_img0.ktx2": _temp2,
  "CL_World_0223_img1.ktx2": _temp3,
  "CL_World_0223_img2.ktx2": _temp4,
  "CL_World_0223_img3.ktx2": _temp5,
  "CL_World_0223_img4.ktx2": _temp6,
  "CL_World_0223_img5.ktx2": _temp7,
  "CL_World_0223_img6.ktx2": _temp8,
  "CL_World_0223_img7.ktx2": _temp9,
  "CL_World_0223_img8.ktx2": _temp10,
  "FF_Chainshroom_0215_img0.ktx2": _temp11,
  "FF_Rotwood_0215_img0.ktx2": _temp12,
  "FF_Shirtdress_0208_img0.ktx2": _temp13,
  "FF_Shirtdress_0208_img1.ktx2": _temp14,
  "FF_World_0223_img0.ktx2": _temp15,
  "FF_World_0223_img1.ktx2": _temp16,
  "FF_World_0223_img2.ktx2": _temp17,
  "FF_World_0223_img3.ktx2": _temp18,
  "FF_World_0223_img4.ktx2": _temp19,
  "FF_World_0223_img5.ktx2": _temp20,
  "FF_World_0223_img6.ktx2": _temp21,
  "FF_World_0223_img7.ktx2": _temp22,
  "FF_World_0223_img8.ktx2": _temp23,
  "FF_World_0223_img9.ktx2": _temp24,
  "FT_Bomber_0211_img0.ktx2": _temp25,
  "FT_Bomber_0211_img1.ktx2": _temp26,
  "FT_KnitVest_0211_img0.ktx2": _temp27,
  "FT_KnitVest_0211_img1.ktx2": _temp28,
  "FT_Multipod_0216_img0.ktx2": _temp29,
  "FT_Shirtdress_0211_img0.ktx2": _temp30,
  "FT_Shirtdress_0211_img1.ktx2": _temp31,
  "FT_Swellberries_0216_img0.ktx2": _temp32,
  "FT_World_0302_img0.ktx2": _temp33,
  "FT_World_0302_img1.ktx2": _temp34,
  "FT_World_0302_img10.ktx2": _temp35,
  "FT_World_0302_img11.ktx2": _temp36,
  "FT_World_0302_img12.ktx2": _temp37,
  "FT_World_0302_img13.ktx2": _temp38,
  "FT_World_0302_img14.ktx2": _temp39,
  "FT_World_0302_img15.ktx2": _temp40,
  "FT_World_0302_img2.ktx2": _temp41,
  "FT_World_0302_img3.ktx2": _temp42,
  "FT_World_0302_img4.ktx2": _temp43,
  "FT_World_0302_img5.ktx2": _temp44,
  "FT_World_0302_img6.ktx2": _temp45,
  "FT_World_0302_img7.ktx2": _temp46,
  "FT_World_0302_img8.ktx2": _temp47,
  "FT_World_0302_img9.ktx2": _temp48,
  "Look_CL_GreenFurSweater_0211_img0.ktx2": _temp49,
  "Look_CL_GreenFurSweater_0211_img1.ktx2": _temp50,
  "Look_CL_Poncho_0211_img0.ktx2": _temp51,
  "Look_CL_Poncho_0211_img1.ktx2": _temp52,
  "Look_CL_ShirtChino_0214_img0.ktx2": _temp53,
  "Look_CL_ShirtChino_0214_img1.ktx2": _temp54,
  "Look_CL_TeePintuckPant_0211_img0.ktx2": _temp55,
  "Look_CL_TeePintuckPant_0211_img1.ktx2": _temp56,
  "Look_FF_CropSweater_0220_img0.ktx2": _temp57,
  "Look_FF_CropSweater_0220_img1.ktx2": _temp58,
  "Look_FF_RibSweater_0220_img0.ktx2": _temp59,
  "Look_FF_RibSweater_0220_img1.ktx2": _temp60,
  "Look_FF_Shirtdress_0220_img0.ktx2": _temp61,
  "Look_FF_Shirtdress_0220_img1.ktx2": _temp62,
  "Look_FF_Shirtdress_0330_img0.ktx2": _temp63,
  "Look_FF_Shirtdress_0330_img1.ktx2": _temp64,
  "Look_FT_Coveralls_0214_img0.ktx2": _temp65,
  "Look_FT_Coveralls_0214_img1.ktx2": _temp66,
  "Look_Placeholder_img0.ktx2": _temp67
}